module.exports = __webpack_public_path__ + "static/media/men_f_thumb.fae851a4.webp";